module.exports = __webpack_public_path__ + "img/sonargroup-main.dff1e921.jpg";